// pin settings:

import { useContext } from "react";
import { FormTypeContext } from "./tab/RouletteItemDesignTab";
import { SettingType } from "./utils/SettingType";
import { Close, Cube, Image } from "grommet-icons";
import { rouletteItemBgType, roulettePinType } from "../RouletteConstants";
import { ImageSettingsForm } from "./sections/ImageSettingsForm";
import { Box, FormField, Select, Tab, Tabs, TextInput } from "grommet";
import RangeInputWithEdit from "../../../forms/RangeInputWithEdit";
import ShadowSettingsForm from "./sections/ShadowSettingsForm";
import { BoxShadow } from "../../../icons/BoxShadow";
import { VectorSettingsForm } from "./sections/VectorSettingsForm";
import { useTranslation } from "react-i18next";

/*
- None
- Image: image, hue, saturation, shadow
*/

const typeOptions = [
    { labelKey: 'optionNone', icon: <Close/>, value: roulettePinType.NONE },
    { labelKey: 'optionImage', icon: <Image/>, value: roulettePinType.IMAGE },
    { labelKey: 'optionVector', icon: <Cube/>, value: roulettePinType.VECTOR },
]

const RoulettePinSettings = () => {

    const { t } = useTranslation('roulette');
    const { pinType: type } = useContext(FormTypeContext);

    return (
        <Box gap="medium">
            <FormField label={t('typeLabel')}>
                <Select
                    name="pinType"
                    options={typeOptions} 
                    labelKey={(option) => <SettingType option={{ ...option, label: t(option.labelKey) }} />}
                    valueKey={{ key: 'value', reduce: true }}
                    // value={type}
                    // onChange={({ value }) => setType(value)}
                />
            </FormField>
            {type !== roulettePinType.NONE && <PinSettingsForm type={type} />}
        </Box>
    )
}

const PinSettingsForm = ({ type }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box>
            <Tabs>
                <Tab title={type === rouletteItemBgType.IMAGE ? t('imageTabTitle') : t('vectorTabTitle')} icon={type === rouletteItemBgType.IMAGE ? <Image/> : <Cube />}>
                    {/* <ImageSettingsForm imageInputName="pinImage" imageHueInputName="pinImageHue" imageSaturationInputName="pinImageSaturation" category="roulette_pin" /> */}
                    {type === roulettePinType.IMAGE && <ImageSettingsForm label={t('imageLabel')} title={t('pinImageBtnTitle')} imageInputName="pinImage" imageHueInputName="pinImageHue" imageSaturationInputName="pinImageSaturation" category="roulette_pin_image" />}
                    {type === roulettePinType.VECTOR && <VectorSettingsForm label={t('pinLabel')} title={t('vectorBtnTitle')} vectorInputName="pinImage" color1InputName="pinColor1" color2InputName="pinColor2" colorGradientAngleInputName="pinColorGradientAngle" outlineWidthInputName="pinOutlineWidth" outlineColorInputName="pinOutlineColor" category="roulette_pin_vector" />}
                    {/* <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
                        <FormField label="Color 1">
                            <TextInput name="pinColor1" type="color" />
                        </FormField>
                        <FormField label="Color 2">
                            <TextInput name="pinColor2" type="color" />
                        </FormField>
                        <FormField label="Angle" noBorder noFocus>
                            <RangeInputWithEdit name="pinColorGradientAngle" type="number" unit={'°'} min={0} max={360} step={1} />
                        </FormField>
                        <FormField label="Outline width" noBorder noFocus>
                            <RangeInputWithEdit name="pinOutlineWidth" type="number" unit={'px'} min={0} max={50} step={1} />
                        </FormField>
                        <FormField label="Outline color">
                            <TextInput name="pinOutlineColor" type="color" />
                        </FormField>
                    </Box> */}
                </Tab>
                <Tab title={t('shadowTabTitle')} icon={<BoxShadow/>}>
                    <ShadowSettingsForm 
                        shadowColorInputName="pinShadowColor"
                        shadowHorizontalOffsetInputName="pinShadowHorizontalOffset"
                        shadowVerticalOffsetInputName="pinShadowVerticalOffset"
                        shadowBlurInputName="pinShadowBlur"
                    />
                </Tab>
            </Tabs>
        </Box>
    )
}

export default RoulettePinSettings;
